import createColorInterpolator from './createColorInterpolator';
export default function applyInterpolate(config, scale) {
  if ('interpolate' in config && typeof config.interpolate !== 'undefined' && 'interpolate' in scale) {
    scale.interpolate(createColorInterpolator(config.interpolate));
  }
}